



































































import { ErrorCodes } from '@ringana/errors';
import Vue from 'vue';
import FetchError from '@/errors/fetch-error';
import { IProduct } from '@/common/interfaces/products.interface';
import CookieHelper from '../../../helpers/CookieHelper';
import DataLayerHelper from '../../../helpers/DataLayerHelper';
import ProductHelper from '../../../helpers/ProductHelper';
import { EProductSliderType } from '@/common/enums/index.enum';
import { IStyleObject } from '@/common/interfaces/index.interface';
import { ISlideProductTexts } from '@/common/interfaces/translations/component.translations.interface';
import FormatHelper from '../../../helpers/FormatHelper';
import OldFormatHelper from '../../../helpers/OldFormatHelper';

export default Vue.extend({
  name: `SlideProduct`,
  data() {
    return {
      additionalUnitData: ``,
      loading: false,
    };
  },
  computed: {
    basePrice(): string {
      return `${this.product.contentsAmount} ${this.$t(this.product.unitContents ?? ``)} (${OldFormatHelper.getPrice(this.product.basePrice.brutto, this.product.currency)} / ${this.product.basePrice.amount} ${this.$t(this.product.basePrice.unit ?? ``)})`;
    },
    formattedTitle(): string {
      return FormatHelper.replaceUnicodeChars(this.product.title);
    },
    price(): string {
      let price = 0;
      if(this.isPartner) {
        price = this.product.prices.partner.brutto;
      } else {
        price = this.product.prices.customer.brutto;
      }
      return OldFormatHelper.getPrice(price, this.product.currency);
    },
    priceWithoutDiscount(): string | null {
      let priceWithoutDiscount = null;
      if(this.isPartner) {
        priceWithoutDiscount = this.product.prices.partner.bruttoWithoutDiscount ?? null;
      } else {
        priceWithoutDiscount = this.product.prices.customer.bruttoWithoutDiscount ?? null;
      }
      return priceWithoutDiscount ? OldFormatHelper.getPrice(priceWithoutDiscount, this.product.currency) : null;
    },
    styleObject(): IStyleObject {
      return { backgroundImage: `url(${this.product.image}&h=300)` };
    },
  },
  props: {
    isPartner: {
      required: true,
      type: Boolean,
    },
    product: {
      required: true,
      type: Object as () => IProduct,
    },
    texts: {
      required: true,
      type: Object as () => ISlideProductTexts,
    },
    type: {
      default: EProductSliderType.SQUARE,
      validator: val => Object.values(EProductSliderType).includes(val),
    },
  },
  async mounted(): Promise<void> {
    await this.setAdditionalUnit();
  },
  methods: {
    async addItemToCart(): Promise<void> {
      const { matchcode } = this.product;
      this.loading = true;

      const body = {
        amount: 1,
        matchcode,
      };

      try {
        await this.$cartService.addItemToCart(body, CookieHelper.getLastUsedCartId() ?? CookieHelper.getPersonalUseCartId());
      } catch (err) {
        if(!(err instanceof FetchError && err.errorCode === ErrorCodes.LIMITING_BOUNCER_ACTIVE)) {
          throw err;
        }
        // all good, hodor should be active now
      }

      const atcProducts = {
        id: this.product.matchcode,
        name: this.product.title,
        price: ProductHelper.getPriceUnformatted(this.isPartner, this.product.prices),
        quantity: 1,
      };
      DataLayerHelper.setProductInfoOnAddToCartToGtm(atcProducts);
      this.loading = false;
    },
    async getPriceString(price: number | null): Promise<string> {
      if(!this.$currencyService.hasCurrencies()) {
        await this.$currencyService.fetchCurrencies();
      }
      const currencySymbol = this.$currencyService.getCurrencySymbol(this.product.currency);
      return `${currencySymbol} ${FormatHelper.formatPrice(price)}`;
    },
    async setAdditionalUnit(): Promise<void> {
      const wpProductData = await this.$wpApiService.getExtendedSingleProductData(
        this.product.link.split(`/`)[2],
        CookieHelper.getLanguage(),
        this.product.image,
      );
      if(this.product.basePrice.brutto && wpProductData.unitPriceData.amount !== null && wpProductData.unitPriceData.amount > 0 && wpProductData.unitPriceData.type !== null) {
        const { text, unitPriceType } = ProductHelper.formatAdditionalUnitPrice(this.product, wpProductData.unitPriceData, this.isPartner);
        this.additionalUnitData = text.replaceAll(`{{unitPriceType}}`, this.$t(unitPriceType));
      }
    },
  },
});
